var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 34,
    viewBox: "0 0 71 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6142 24.505H15.0681H3.77496C2.13232 24.505 0.941406 23.7247 0.941406 22.657C0.941406 18.304 1.39313 15.183 2.37872 12.8423C3.65176 9.72124 5.86933 8.03753 8.94927 7.8322C11.7007 3.19174 17.3678 0.0296631 22.9528 0.0296631H34.6977C39.6666 0.0296631 43.2804 3.23281 45.9087 5.57357C47.1817 6.68235 48.4548 7.8322 49.1529 7.8322H59.5426C64.2241 7.8322 68.1254 11.4049 68.5771 16.0043C69.6448 16.0865 71 16.415 71 17.5648V22.657C71 23.7247 69.8091 24.505 68.2075 24.505H55.7645H17.6142Z",
    fill: "#838EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0647 19.2891C1.10576 18.591 1.1879 17.975 1.27003 17.359H4.71957C5.25343 17.359 5.70515 17.7697 5.70515 18.3035C5.70515 18.8374 5.25343 19.2891 4.71957 19.2891H1.0647Z",
    fill: "#445174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.114 14.1975H29.8929V4.42383H36.9973C37.2437 4.42383 37.4491 4.50596 37.6544 4.67022L46.73 12.5138C47.0585 12.7602 47.1406 13.1709 47.0174 13.5405C46.8942 13.9511 46.5246 14.1975 46.114 14.1975ZM27.9628 14.1975H12.9737C12.6041 14.1975 12.2756 13.9511 12.1113 13.6226C11.9471 13.2941 12.0292 12.8834 12.2756 12.596L19.0926 4.75236C19.2979 4.54703 19.5443 4.42383 19.8317 4.42383H27.9628V14.1975Z",
    fill: "#E4E6EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3411 32.5127C11.947 32.5127 8.37427 28.94 8.37427 24.5459C8.37427 20.1518 11.947 16.5791 16.3411 16.5791C20.7351 16.5791 24.3079 20.1518 24.3079 24.5459C24.3079 28.94 20.7351 32.5127 16.3411 32.5127Z",
    fill: "#AF8EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2429 32.5124C52.8489 32.5124 49.2761 28.9397 49.2761 24.5456C49.2761 20.1515 52.8489 16.5377 57.2429 16.5377C61.637 16.5377 65.2097 20.1515 65.2097 24.5456C65.2097 28.9397 61.637 32.5124 57.2429 32.5124Z",
    fill: "#AF8EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.341 28.4883C14.1645 28.4883 12.3987 26.7225 12.3987 24.546C12.3987 22.3695 14.1645 20.6036 16.341 20.6036C18.5175 20.6036 20.2834 22.3695 20.2834 24.546C20.2834 26.7225 18.5175 28.4883 16.341 28.4883Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5771 33.9711H3.40538C2.87153 33.9711 2.4198 33.5605 2.4198 33.0266C2.4198 32.4927 2.87153 32.041 3.40538 32.041H68.5771C69.111 32.041 69.5216 32.4927 69.5216 33.0266C69.5216 33.5605 69.111 33.9711 68.5771 33.9711Z",
    fill: "#394461"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2429 28.4883C55.0664 28.4883 53.3005 26.7225 53.3005 24.546C53.3005 22.3695 55.0664 20.6036 57.2429 20.6036C59.4194 20.6036 61.1852 22.3695 61.1852 24.546C61.1852 26.7225 59.4194 28.4883 57.2429 28.4883Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2372 20.4396H26.197C25.7042 20.4396 25.2524 20.029 25.2524 19.4951C25.2524 18.9612 25.7042 18.5095 26.197 18.5095H46.2372C46.771 18.5095 47.1817 18.9612 47.1817 19.4951C47.1817 20.029 46.771 20.4396 46.2372 20.4396Z",
    fill: "#445174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.c702d06a9f0ff0cc3c0b7faf2a50eb7e.svg";
export { ForwardRef as ReactComponent };